// initial slick carousel
$(function() {
    $('.hero-video-carousel').slick({
        slidesToShow: 1,
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 5000,
        adaptiveHeight: true,
        useTransform: false
    });
    // $('.fw-modal__media-carousel-wrap').addClass('initialized');
});